import { Navigate, useParams } from 'react-router-dom';

/**
 * Legacy `/patients/:id/profile` and `/patients/:id/insurance` now fold into
 * the single patient page at `/patients/:id` (insurance only, no sub-nav).
 */
export function PatientTabRedirect() {
  const { patientId } = useParams<{ patientId: string }>();
  return <Navigate to={`/patients/${patientId ?? ''}`} replace />;
}
